import { SxProps, Theme } from "@mui/system";

export function listRequestsWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1,
        width: "100%",
        borderRadius: "20px",
        my: "24px",
    };
}

export function listRequestsTitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        paddingTop: "0.3em",
        paddingBottom: 0,
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec",
    };
}

export function tableContainer(theme: Theme): SxProps<Theme> {
    return {
        overflow: "auto",
        maxHeight: `100%`,
        height: `100%`,
    };
}

export function createButton(theme: Theme): SxProps<Theme> {
    return {
        marginBottom: "1rem",
        marginTop: "1rem",
    };
}
